import { render, staticRenderFns } from "./sundry-payment.vue?vue&type=template&id=a4e56d52"
import script from "./sundry-payment.vue?vue&type=script&lang=js"
export * from "./sundry-payment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports